import { render, staticRenderFns } from "./FacturaDetail.vue?vue&type=template&id=051534e8"
import script from "./FacturaDetail.vue?vue&type=script&lang=js"
export * from "./FacturaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports